import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IAdminAuthSlice,
  IAdminDetails,
} from "../../models/admin/adminAuth/adminAuth";
import {
  adminLogin,
  adminResetPassword,
  getAdminDetails,
} from "./adminAuthActions";

const initialState: IAdminAuthSlice = {
  adminDetails: null,
  adminDetailsData: { email: "" },
  isUpdated: "",
};

const adminAuthSlice = createSlice({
  name: "adminAuth",
  initialState: initialState,
  reducers: {
    setAdminDetails: (state, { payload }: PayloadAction<IAdminDetails>) => {
      state.adminDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(adminLogin.fulfilled, (state, { payload }) => {
      state.adminDetails = payload.data;
    });
    builder.addCase(adminResetPassword.fulfilled, (state, { payload }) => {
      state.isUpdated = payload.data;
    });
    builder.addCase(getAdminDetails.fulfilled, (state, { payload }) => {
      state.adminDetailsData = payload.data;
    });
  },
});

export default adminAuthSlice.reducer;

export const { setAdminDetails } = adminAuthSlice.actions;
